import React, {Fragment} from 'react';
import {useTheme} from '@mui/material';
import type {NoProps} from 'types';
import {selectHead} from 'services/head/headSlice';
import {useAppSelector} from 'store/hooks';

type Props = NoProps;

export const Head: React.FC<Props> = () => {
  const {title, description} = useAppSelector(selectHead);
  const {palette} = useTheme();

  return (
    <Fragment>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content={palette.primary.main} />
      <meta name="description" content={description} />
      <title>{title ? `${title} | Ebba` : 'Ebba'}</title>
    </Fragment>
  );
};
